export default __webpack_public_path__ + "static/media/search-icon.13fa40ee.svg";